export const storageEnabled = process.env.REACT_APP_STORAGE_ENABLED === 'true';
const WEB3FORMS_KEY = 'c98d7adb-6e49-4ef4-aef3-ab94bb396534';

export function validateAttachments(files) {
  if (files.length > 3) throw new Error('Trois fichiers maximum.');
  for (const file of files) {
    if (!/\.(pdf|docx|jpe?g|png)$/i.test(file.name)) throw new Error('Formats acceptés : PDF, DOCX, JPG et PNG.');
    if (!file.size || file.size > 5 * 1024 * 1024) throw new Error('Chaque fichier doit faire au maximum 5 Mo.');
  }
}

export async function submitRequest(kind, payload, form) {
  payload = Object.fromEntries(Object.entries(payload).map(([key, value]) => [key, String(value ?? '')]));
  const files = Array.from(form?.elements.namedItem('attachments')?.files || []);
  validateAttachments(files);
  const botcheck = !!form?.elements.namedItem('botcheck')?.checked;
  if (botcheck) throw new Error('Demande non valide.');
  let url = 'https://api.web3forms.com/submit';
  let options;
  if (storageEnabled) {
    // Keep this ID for a retry of the same content, but never put personal data in browser storage.
    const fingerprint = JSON.stringify([kind, payload, files.map(f => [f.name, f.size, f.lastModified])]);
    if (!form._mceRequest || form._mceRequest.fingerprint !== fingerprint) form._mceRequest = { fingerprint, id: crypto.randomUUID() };
    const body = new FormData();
    body.append('request_id', form._mceRequest.id);
    body.append('kind', kind);
    body.append('payload', JSON.stringify(payload));
    files.forEach(file => body.append('attachments[]', file));
    url = '/api/submit.php';
    options = { method: 'POST', body, credentials: 'same-origin' };
  } else if (files.length) {
    const body = new FormData();
    body.append('access_key', WEB3FORMS_KEY);
    body.append('from_name', 'Site MCE France');
    Object.entries(payload).forEach(([key, value]) => body.append(key, value));
    files.forEach(file => body.append('attachment', file));
    options = { method: 'POST', body };
  } else {
    options = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ access_key: WEB3FORMS_KEY, from_name: 'Site MCE France', ...payload }) };
  }
  const response = await fetch(url, options);
  const result = await response.json();
  if (!response.ok || !result.success) throw new Error(result.message || 'Envoi impossible. Réessayez plus tard.');
  if (form) {
    delete form._mceRequest;
    const attachmentInput = form.elements.namedItem('attachments');
    if (attachmentInput) attachmentInput.value = '';
  }
  return result;
}
